import { CompanyDetailPage } from "@/features/company/pages/CompanyDetail";

const CompanyDetail = () => {
  return <CompanyDetailPage />;
};

export default CompanyDetail;
